import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';

import { IPagedRequest, IPagedResponse, IProfileEvent, SortDirection } from '../../shared/interfaces';
import { ApiService } from '../../shared/api.service';
import { EventType } from '../../shared/enums';
import { TranslationKey } from 'src/app/enums';

@Component({
    selector: 'aza-rws-profile-events',
    templateUrl: 'events.component.html',
    styleUrls: ['events.component.css'],
    standalone: false
})
export class EventsComponent implements OnInit {
    @Input() eventType: EventType;
    @Input() restrictToEventId?: string;

    pagedReq: IPagedRequest;
    pagedRes: IPagedResponse;
    events: IProfileEvent[] = [];
    pagedResponseSubject = new Subject<IPagedResponse>();
    titleTranslationKey: string;
    eventSearchText = '';
    participantSearchText = '';
    myOrganization = false;

    @Output() closed = new EventEmitter<void>();
    @Output() eventClicked = new EventEmitter<IProfileEvent>();

    constructor(private apiSvc: ApiService) {
    }

    async ngOnInit(): Promise<void> {
        this.titleTranslationKey = this.eventType === EventType.event ? TranslationKey.events : TranslationKey.requests;
        this.pagedRes = { offset: 0, limit: 0, object_count: 0 };
        this.pagedReq = { limit: 5, offset: 0 };
        this.loadEvents(this.pagedReq);
    }

    async loadEvents(pagedReq: IPagedRequest): Promise<void> {
        const res = await this.apiSvc.searchEvents(
            null,
            this.eventType,
            this.eventSearchText,
            this.participantSearchText,
            this.myOrganization,
            pagedReq,
            'start',
            SortDirection.desc,
            this.restrictToEventId,
        );
        this.events = res.events;
        this.pagedResponseSubject.next(res);
    }

    onFilterChanged(): void {
        // TODO: Debounce
        this.loadEvents(this.pagedReq);
    }

    onPagingOffsetChanged(newOffset: number): void {
        this.pagedReq.offset = newOffset;
        this.loadEvents(this.pagedReq);
    }

    onClosed(): void {
        this.closed.next();
    }

    onEventClick(evt: IProfileEvent): void {
        this.eventClicked.next(evt);
    }
}
